const React = require('react');
const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const delay = require('mn-utils/delay');
const noop = require('mn-utils/noop');
const withDefer = require('mn-utils/withDefer');
const isNumber = require('mn-utils/isNumber');
const throttle = require('mn-utils/throttle');
const {
  List,
} = require('react-virtualized/dist/commonjs/List');
const {
  AutoSizer,
} = require('react-virtualized/dist/commonjs/AutoSizer');
const {
  replaceLocation,
  location$,
} = require('../router');
const {
  paramStore,
} = require('../stores');
const withState = require('./withState');
const WrapperWithLoading = require('../components/dumb/WrapperWithLoading');
const {apiV2ReferralMerchantsList} = require('../api/referral/merchants');


module.exports = (options) => {
  const {
    rowHeight,
    wrapper,
    requestWrapper,
    request,
    enableAPISorter,
    nodata,
  } = options;
  const getParams = options.getParams || noop;
  const nextLoading$ = new Emitter(0);
  const nextLoadingEmit = nextLoading$.emit;
  const params$ = paramStore('p');
  const paramsSet = params$.set.bind(params$);
  const paramsOut$ = params$.map((params) => {
    const _params = params || {};
    const [name, reverse] = ('' + (_params.sort || '')).split('!');
    return {
      ..._params,
      sort: {
        name: name || reverse || '',
        reverse: !!reverse,
      },
    };
  });


  const PaginationLoading = withState(() => {
    return (state) => {
      return (
        <WrapperWithLoading
          className="w"
          loading={state.loading}
        />
      );
    };
  }, {
    loading: nextLoading$,
  });


  return withState((setState, self, onMount) => {
    let _stop;
    let _locked = 1;
    const updateParam = throttle((args) => {
      if (_stop) {
        return;
      }
      const loc = location$.getValue();
      replaceLocation({
        path: loc.path,
        query: {
          ...loc.query,
          s: args,
        },
      });
    });
    const loc = location$.getValue();
    const query = loc.query || {};
    const args = query.s || [];

    self.state = {
      ...(self.state || {}),
      scrollTop: args[0] || 0,
    };


    onMount(() => {
      setState({
        loading: true,
      });

      getData({
        offset: 0,
        limit: !args[1] || args[1] > 100 ? 50 : args[1],
      }).finally((error, data) => {
        const _state = {
          loading: false,
          error,
        };

        error || (_state.data = data);
        setState(_state);
        delay(() => {
          _locked = 0;
        }, 100);
      });
      return () => {
        _stop = 1;
      };
    });

    function getData(params) {
      const _params = {
        skipError: 1,
        ...(getParams(self) || {}),
        ...params,
      };
      return requestWrapper
        ? requestWrapper(self, request, _params) || CancelablePromise.resolve()
        : request(_params);
    }

    self.handleSortProvider = (propName) => {
      return () => {
        const {
          state,
        } = self;
        const params = state.params || {};
        const sort = params.sort || {};
        paramsSet({
          sort: sort.name == propName
            ? (sort.reverse ? null : ('!' + propName))
            : propName,
        });
      };
    };

    const update = self.update = () => {
      const {
        state,
      } = self;
      const data = state.data || {};
      const items = data.list || [];

      setState({
        loading: true,
      });

      getData({
        offset: 0,
        limit: !args[1] || args[1] > 100 ? 50 : args[1],
      }).finally((error, data) => {
        const _state = {
          loading: false,
          error,
        };
        error || (_state.data = data);
        setState(_state);
      });
    };

    self.handleToUp = () => {
      setState({
        scrollTop: 0,
      });
    };

    enableAPISorter && paramsOut$.on(withDefer(update));

    function render(Item) {
      const {
        state,
      } = self;
      const {
        error,
        loading,
        showUp,
      } = state;
      const _data = state.data;
      const data = _data || {};
      let items = data.list || [];
      const length = items.length || 0;
      const offset = length;
      const count = data.count || length;
      const params = state.params || {};
      const sort = params.sort;
      const {
        name,
        reverse,
      } = sort;

      if (!enableAPISorter && name) {
        items = [...items].sort((a, b) => {
          b = b[name];
          a = a[name];
          if (isNumber(a)) {
            a = (a - b);
          } else if (a) {
            a = a.localeCompare(b);
          }
          return reverse ? -a : a;
        });
      }

      function next() {
        if (loading || nextLoading$.getValue()) return;
        if (!_data) return;
        name && paramsSet({
          sort: null,
        });

        return offset === count || (nextLoadingEmit(1), getData({
          offset,
        }).finally((error, response, list) => {
          delay(nextLoadingEmit, 0, [0]);
          const _state = {
            error,
          };
          error || (_state.data = {
            list: list = items.concat(response.list || []),
            count: response.count || list.length,
          });
          setState(_state);
        }));
      }


      return (
        <WrapperWithLoading
          className="sq"
          inner={{
            className: 'sq',
          }}
          loading={loading}
        >
          {
            error ? (
              <div className="p15 ph35">
                <div
                  className="hmin100 layoutRow fhaC fvaC p15 cF00 bgD r5
                  (dn|cCT|olN|tdU|o70:h!)>a"
                >
                  <span dangerouslySetInnerHTML={{
                    __html: error.message || '',
                  }}/>
                </div>
              </div>
            ) : (
              <AutoSizer className="sq-i">
                {({height, width}) => {
                  const withoutScroll = height > count * rowHeight;
                  // console.log(height, count * rowHeight)
                  return (
                    <List
                      width={width}
                      height={height}
                      rowCount={length + (count === length ? 0 : 1)}
                      rowHeight={rowHeight}
                      scrollTop={state.scrollTop}
                      onScroll={({scrollTop}) => {
                        if (_locked) {
                          return;
                        }
                        setState({
                          scrollTop,
                        });
                        updateParam([scrollTop, length]);
                      }}
                      onRowsRendered={({overscanStartIndex}) => {
                        const _showUp = overscanStartIndex > 5;
                        showUp === _showUp || setState({
                          showUp: _showUp,
                        });
                      }}
                      rowRenderer={({key, index, style}) => {
                        const item = items[index];
                        return (
                          <div
                            className={'layoutRow fvaC pr8.withoutScroll' + (withoutScroll ? ` withoutScroll` : '')}
                            key={key || (item ? item.id : index)}
                            style={style}
                          >
                            {
                              length === index
                                ? (next(), (
                                  <PaginationLoading/>
                                ))
                                : (
                                  <Item
                                    data={item}
                                    update={self.update}
                                    index={index}
                                  />
                                )
                            }
                          </div>
                        );
                      }}
                      noRowsRenderer={() => (
                        <div
                          className="layoutRow fvaC"
                        >
                          {nodata || (<div className="f16 fw4 mt20 ttU tc w">No data</div>)}
                        </div>
                      )}
                    />
                  );
                }}
              </AutoSizer>
            )
          }
        </WrapperWithLoading>
      );
    }

    return wrapper(render, setState, self);
  }, {
    params: paramsOut$,
    ...(options.state || {}),
  });
};
